<template>
    <div v-if="isDisplay"
        :class="['preview-loading-icon', formLoadingIcon.positionIndex != maxComponent - 1 ? 'm-b-16' : '']">
        <div :class="['swift-loading-icon', formLoadingIcon.size ]">
            <template v-if="currentIcon.src == undefined || currentIcon.src == null">
                <div :class="'preview-icon-'+currentIcon.key" v-html="currentIcon.code"></div>
            </template>
            <template v-else>
                <img :class="'preview-icon-'+currentIcon.key" :src="getImgUrl(currentIcon.src)" alt="">
            </template>
        </div>
    </div>
</template>

<script>
import { icons as loadingIcons } from './../../constant'
import { listComponentDefault } from './../../constant'
export default {
    name: "PreviewLoadingIcon",
    props: {
        value: {
            type: Object,
            required: true,
        },
        isDisplay: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        formLoadingIcon: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", this.value);
            },
        },
        currentIcon() {
            return loadingIcons.find(icon => this.formLoadingIcon.icon == icon.key)
        },
        background() {
            return this.formLoadingIcon.background
        },
        maxComponent() {
            return listComponentDefault.length
        }
    },
    watch: {
        background: {
            handler(value) {
                this.updateStyle()
            },
            deep: true
        },
        currentIcon: {
            handler(value) {
                this.updateStyle()
            },
            deep: true
        },
        isDisplay: {
            handler(value) {
                if (value) {
                    this.updateStyle()
                }
            },
            deep: true
        }
    },
    data() {
        return {
           
        };
    },
    created() {
        this.updateStyle()
    },
    methods: {
        updateStyle() {
            if ( this.isDisplay ) {
                setTimeout(() => {
                    let element = $('.preview-icon-'+this.currentIcon.key)[0]
                    switch (String(this.currentIcon.key)) {
                        case 'lds-ring':
                            element = $($(element).find('.'+this.currentIcon.key)[0]).find('div')
                            for (var i=0; i < element.length; i++) {
                                element[i].style = 'border-color: transparent transparent transparent' + this.formLoadingIcon.background
                            }
                        break;
                        case 'lds-dual-ring':
                            element = $(element).find('.'+this.currentIcon.key)
                            element[0].style.setProperty('--background', this.formLoadingIcon.background)
                        break;
                        case 'lds-ellipsis':
                            let circles = $(element).find('circle')
                            for (var i=0; i < circles.length; i++) {
                                circles[i].style = 'fill: ' + this.formLoadingIcon.background
                            }
                        break;
                        case 'lds-eclipse':
                            $(element).find('path')[0].style = 'fill: ' + this.formLoadingIcon.background
                        break;
                        case 'lds-loader':
                            element = $($(element).find('.'+this.currentIcon.key)[0]).find('span')
                            for (var i=0; i < element.length; i++) {
                                element[i].style = 'border-left-color:' + this.formLoadingIcon.background
                            }
                        break;
                        case 'lds-pen-ring':
                            element = $($(element).find('.'+this.currentIcon.key)[0]).find('div')
                            for (var i=0; i < element.length; i++) {
                                $(element[i]).find('svg')[0].style = 'fill: ' + this.formLoadingIcon.background
                            }
                        break;
                        default:
                            element = $($(element).find('.'+this.currentIcon.key)[0]).find('div')
                            for (var i=0; i < element.length; i++) {
                                element[i].style = 'background: ' + this.formLoadingIcon.background
                            }
                        break;
                    }
                })
            }
        }
    }
};
</script>

<style lang="scss">

</style>
